import { formatCurrency, formatDateTime, formatMonth } from '../config/resources/utils'

const MONTH_NAME_INDEX = {
  enero: 0, january: 0,
  febrero: 1, february: 1,
  marzo: 2, march: 2,
  abril: 3, april: 3,
  mayo: 4, may: 4,
  junio: 5, june: 5,
  julio: 6, july: 6,
  agosto: 7, august: 7,
  septiembre: 8, september: 8,
  octubre: 9, october: 9,
  noviembre: 10, november: 10,
  diciembre: 11, december: 11,
}

function getUtmMonthIndex(utm) {
  if (typeof utm.targetMonthIndex === 'number') return utm.targetMonthIndex
  return MONTH_NAME_INDEX[String(utm.targetMonth).toLowerCase()] ?? -1
}

/**
 * UTM vigente for the current calendar month.
 * Prefers an exact match; otherwise the most recent past/present value
 * (never a future month that may already be scraped).
 */
export function getCurrentUtm(utms = [], now = new Date()) {
  const currentYear = now.getFullYear()
  const currentMonthIndex = now.getMonth()

  const candidates = utms
    .map((utm) => ({
      utm,
      year: Number(utm.targetYear),
      monthIndex: getUtmMonthIndex(utm),
    }))
    .filter(({ year, monthIndex }) =>
      Number.isFinite(year) && monthIndex >= 0 && monthIndex <= 11
    )

  const exact = candidates.find(
    ({ year, monthIndex }) =>
      year === currentYear && monthIndex === currentMonthIndex
  )
  if (exact) return exact.utm

  const pastOrPresent = candidates
    .filter(
      ({ year, monthIndex }) =>
        year < currentYear ||
        (year === currentYear && monthIndex <= currentMonthIndex)
    )
    .sort(
      (a, b) => b.year - a.year || b.monthIndex - a.monthIndex
    )

  return pastOrPresent[0]?.utm || null
}

export function mapUtmFromDb(dbRow) {
  const targetDate = new Date(dbRow.target_month)

  return {
    id: dbRow.id,
    value: formatCurrency(dbRow.value),
    rawValue: dbRow.value,
    source: dbRow.source,
    retrievedAt: formatDateTime(dbRow.retrieved_at),
    targetMonth: formatMonth(dbRow.target_month),
    targetMonthIndex: targetDate.getUTCMonth(),
    targetYear: targetDate.getUTCFullYear(),
  }
}

export function mapUtmToDb(payload) {
  const year = Number(payload.targetYear)
  const monthIndex = Number(payload.targetMonth)
  const targetMonthDate = new Date(Date.UTC(year, monthIndex, 1))

  return {
    value: Number(payload.value),
    source: payload.source,
    target_month: targetMonthDate.toISOString(),
    retrieved_at: new Date().toISOString()
  }
}
